"use strict";
exports.__esModule = true;
exports.fromBase58 = exports.toBase58 = void 0;
var hex_1 = require("./hex");
var bignumber_js_1 = require("bignumber.js");
var ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
var BASE = new bignumber_js_1["default"](ALPHABET.length);
function toBase58(data) {
    var encoded = '';
    if (data instanceof Uint8Array) {
        data = hex_1.toHex(data);
    }
    var num = new bignumber_js_1["default"](data, 16);
    var zero = new bignumber_js_1["default"](0);
    while (num.isGreaterThan(zero)) {
        var pos = num.mod(BASE).toNumber();
        var char = ALPHABET.charAt(pos);
        encoded = char + encoded;
        num = num.dividedToIntegerBy(BASE);
    }
    return encoded;
}
exports.toBase58 = toBase58;
function fromBase58(data) {
    if (data === '' || data === null || data === undefined) {
        return new Uint8Array();
    }
    var answer = new bignumber_js_1["default"](0);
    var base = new bignumber_js_1["default"](1);
    for (var i = data.length - 1; i >= 0; i--) {
        var pos = ALPHABET.indexOf(data.charAt(i));
        if (pos === -1) {
            throw new Error('Invalid Base58 data');
        }
        var num = new bignumber_js_1["default"](pos);
        answer = answer.plus(num.times(base));
        base = base.times(BASE);
    }
    var hex = answer.toString(16);
    if (hex.length % 2 !== 0) {
        hex = '0' + hex;
    }
    return hex_1.fromHex(hex);
}
exports.fromBase58 = fromBase58;
